<template>
  <div>
    <confirm-dialog ref="confirmDialog"></confirm-dialog>
    <div
      v-if="authMessageText"
      class="container-fluid m-3 mb-4"
    >
      <p
        class="bb-message mt-3 p-2"
        style="white-space: pre-line"
      >
        {{ authMessageText }}
      </p>
    </div>
    <div
      v-if="noArenas"
      class="container-fluid m-3 mb-4"
    >
      <p class="bb-no-records mt-3 p-2">You have no campaigns</p>
    </div>
    <!-- <SideBarComponent /> -->
    <div class="bb-arena-listing">
      <!-- loop thru data - call card component -->
      <div
        v-for="arena in arenas"
        :key="arena.id"
      >
        <CampaignCardComponent :arena="arena" />
      </div>
      <!-- get more arenas  -->
      <div class="my-4">
        <span class="background-color: white">
          <p v-show="loadingArenas">...loading...</p>
          <button
            v-show="next"
            @click="listMyArenas"
            class="btn btn-sm btn-outline-success"
          >
            Load More
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
//----------------------
// script
//----------------------
import { axios } from '@/common/api.service.js'
import { mapGetters } from 'vuex'
import CampaignCardComponent from '@/components/CampaignCard.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import createSocketConnection from '../helpers/createSocketConnection'
import formatHiddenRollValue from '../helpers/formatHiddenRollValue'

export default {
  name: 'myCampaignsView',
  components: {
    CampaignCardComponent,
    ConfirmDialog,
  },
  //----------------------
  // data
  //----------------------
  data() {
    return {
      arenas: [],
      connectedArenaSlugs: [],
      connections: [],
      refreshIntervalId: null,
      next: null,
      loadingArenas: false,
      noArenas: false,
    }
  },
  //----------------------
  // computed values
  //----------------------
  computed: {
    ...mapGetters('auth', {
      getHeaders: 'getHeaders',
      getMessage: 'getMessage',
      getUserProfile: 'getUserProfile',
    }),
    authMessageText() {
      if (!this.getMessage) {
        return ''
      }

      if (typeof this.getMessage === 'string') {
        return this.getMessage
      }

      return this.getMessage.text || ''
    },
  },
  methods: {
    startArenaRefreshPolling() {
      if (this.refreshIntervalId) {
        return
      }

      this.refreshIntervalId = window.setInterval(() => {
        this.refreshVisibleArenas()
      }, 5000)
    },
    async refreshVisibleArenas() {
      if (document.hidden || this.arenas.length === 0) {
        return
      }

      await Promise.allSettled(
        this.arenas.map((arena) => this.loadArenaHandler(arena.slug)),
      )
    },
    async showHiddenRollPopup(message = {}) {
      const currentUser = this.getUserProfile || {}
      const currentUserIds = [currentUser?.id, currentUser?.email]
        .filter(
          (value) => value !== null && value !== undefined && value !== '',
        )
        .map((value) => String(value))

      if (!currentUserIds.includes(String(message?.dm_id))) {
        return false
      }

      await this.$refs.confirmDialog?.show?.({
        title: 'Hidden Roll to DM',
        message: `from ${message?.player_name || 'Player'}`,
        subject: formatHiddenRollValue(message?.roll),
        subjectReadonly: true,
        okButton: 'OK',
      })

      return true
    },
    isCurrentUserHiddenRollRecipient(message = {}) {
      const currentUser = this.getUserProfile || {}
      const currentUserIds = [currentUser?.id, currentUser?.email]
        .filter(
          (value) => value !== null && value !== undefined && value !== '',
        )
        .map((value) => String(value))

      return currentUserIds.includes(String(message?.dm_id))
    },
    acknowledgeHiddenRollDelivery(connection, message = {}) {
      if (
        !message?.request_id ||
        !connection ||
        connection.readyState !== WebSocket.OPEN
      ) {
        return
      }

      connection.send(
        JSON.stringify({
          message: {
            type: 'hidden_roll_ack',
            request_id: message.request_id,
          },
        }),
      )
    },
    createSocketConnectionHandler(arena_slug) {
      if (this.connectedArenaSlugs.includes(arena_slug)) {
        return
      }

      let this_connection = createSocketConnection('arena', arena_slug)
      var self = this

      this_connection.onmessage = function (event) {
        const data = JSON.parse(event.data)
        const message = data.message
        console.log('received message = ', message)

        if (message?.type === 'hidden_roll_delivery') {
          if (self.isCurrentUserHiddenRollRecipient(message)) {
            self.acknowledgeHiddenRollDelivery(this_connection, message)
          }
          void self.showHiddenRollPopup(message)
          return
        }

        self.loadArenaHandler(arena_slug)
      }

      this.connections.push(this_connection)
      this.connectedArenaSlugs.push(arena_slug)
    },
    async loadArenaHandler(arena_slug) {
      const headers = this.getHeaders

      await axios
        .get(`api/v1/campaigns/${arena_slug}/`, {
          headers: headers,
          mode: 'same-origin',
        })
        .then((response) => {
          const updatedArena = response.data
          let idx = this.arenas.findIndex((a) => a.slug == arena_slug)

          if (idx >= 0) {
            this.arenas.splice(idx, 1, updatedArena)
          }
        })
        .catch((err) => {
          console.log('Failed to refresh campaign after websocket update', err)
        })
    },
    //----------------------
    // list campaigns
    //----------------------
    async listMyArenas() {
      this.errors = []
      //-------------------------
      // setup call parms
      //-------------------------
      const headers = this.getHeaders
      //-------------------------
      // get all or my campaigns
      //-------------------------
      let endpoint = 'api/v1/campaigns/my/'
      //-------------------------
      // manage rolling endpoint
      //-------------------------
      if (this.next) {
        endpoint = this.next
      }
      this.loadingArenas = true
      //----------------------
      // api call
      //----------------------
      await axios
        .get(endpoint, {
          headers: headers,
        })
        //----------------------
        // where successful
        //----------------------
        .then((response) => {
          // console.log("YO - got arenas");
          const resultsArray = response.data.results
          this.loadingArenas = false

          if (resultsArray.length == 0) {
            this.noArenas = true
          } else {
            this.noArenas = false
            this.arenas.push(...resultsArray)
            resultsArray.forEach((arena) => {
              this.createSocketConnectionHandler(arena.slug)
            })
            this.startArenaRefreshPolling()
            if (response.data.next) {
              this.next = response.data.next
            } else {
              this.next = null
            }
          }
        })
        //----------------------
        // where error
        //----------------------
        .catch((err) => {
          if (err.response) {
            const errMsgArray = err.response.data.non_field_errors
            for (var i = 0; i < errMsgArray.length; i++) {
              this.errors.push(errMsgArray[i].toString())
            }
          }
        })
    },
  },
  //-------------------------
  // on created
  //-------------------------
  created() {
    this.listMyArenas()
  },
  beforeUnmount() {
    if (this.refreshIntervalId) {
      window.clearInterval(this.refreshIntervalId)
      this.refreshIntervalId = null
    }

    this.connections.forEach((connection) => {
      if (connection && connection.readyState === WebSocket.OPEN) {
        connection.close()
      }
    })
    this.connections = []
    this.connectedArenaSlugs = []
  },
}
</script>
